import request from 'tools/request'

export const getStateOptions = async () => {
  const res = await request.get('commonresource/statelist')
  return res?.data
}
